var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{ref:"container",class:_vm.$style.textViewer})}
var staticRenderFns = []

export { render, staticRenderFns }